import React from "react";
// import HomeSection1Card from "./HomeSection1Card";
import innerimg from "../../../images/homeimage/innerimg.jpg"
const HomeSection1 = () => {
  return (
    <div id="about-school">
      <div className="relative mt-20 flex justify-between lg:mt-40">
        <div className="mx-5 border-4 border-x-blue-900 border-y-blue-900 lg:w-[50%]">
          <div className="mx-5 mt-9 leading-6">
            <h1 className="text-3xl font-bold mt-20">
              WELCOME TO S.S. PUBLIC SCHOOL
            </h1>
            <h2 className="mt-2 text-2xl font-semibold text-sky-600">
              Encouraging Little Innovators
            </h2>
            <p className="mt-7 text-xl lg:text-justify">
              <a className=" font-bold  "> S. S. Public School</a> in Agra has
              truly given children all that is needed to transform them into
              confident individuals. The school life has not only given them a
              platform for individual activities but also provided impetus to be
              a good team member through various sports and club activities.
              School’s campus has been designed to give students an open and
              healthy learning environment. Every child has ample space and a
              range of learning aids. The varied interests and capabilities of
              children are acknowledged by providing for different activities.
            </p>
            <br />

            {/* <p className=" text-xl text-justify">
              That the present education system is hardly adequate to equip the
              students to face the challenges of a fast changing modern world is
              an undeniable fact. We, the members
              <br />
              of S.S. PUBLIC SCHOOL are convinced that radical changes have to
              be effected in the teaching methodology and course contents so
              that the system of education is not
              <br />
              merely information based but value oriented formulated to bring
              about transformation
              <br />
              and maturity in the personality of the students.
            </p> */}
          </div>
          <div className="mx-10 justify-evenly pb-12 lg:flex">
            <div className="mt-10 h-44 border px-5 pt-14 text-center shadow-2xl">
              <ul>
                <li className="text-3xl font-bold">15+</li>
                <li className="text-xl">experience years</li>
              </ul>
            </div>
            <div className="mt-10 h-44 border px-5 pt-14 text-center shadow-2xl">
              <ul>
                <li className="text-3xl font-bold">500+</li>
                <li className="text-xl">students strength</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="absolute right-36 -bottom-32 hidden w-[45%] bg-white lg:block lg:w-[42%]">
          <div className="h-full w-full pt-14">
            <img
              className="float-right hidden h-[90%] w-[90%] lg:block"
              src={innerimg}
              alt=""
            />
          </div>
        </div> 
      </div>
    </div>
  );
};

export default HomeSection1;
